/**
 * 根布局：负责整体页面骨架（顶部导航 + 居中内容区）。
 */

import type { ReactElement } from 'react'
import { Outlet } from 'react-router-dom'
import { Navbar } from './Navbar'

/**
 * 根布局组件。
 * @returns ReactElement
 */
export function RootLayout(): ReactElement {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
